// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1d9136c3","453":"dbff9348","798":"d6627245"}[chunkId] + ".chunk.js";
};